<template>
    <div class="help-module" v-if="!closeHelpModule">
        <div class="help-module__content">
            <div class="help-module__drako-reaction">
                <div ref="drakoTop" class="drako-reaction">
                    <p class="typed"></p>
                    <div class="drako-reaction__btn-close" @click="closeTalk">
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                    </div>
                    <div ref="drakoMobail" class="drako-reaction__btn-next" @click="nextTalk">
                        <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="help-module__drako-talk">
                    <img :data-gifffer='this.data.imgDrako'>
                </div>
            </div>
        </div>
        <div class="help-module__background"></div>
    </div>
</template>

<script>
import Vue from 'vue'
import Typed from 'typed.js'
import Gifffer from 'gifffer';
import fontawesome from '@fortawesome/fontawesome-free/js/all.min'

export default {
    props:['data'],
    data(){
        return{
            phraseNumber:0,
            closeHelpModule:false,
            animDrako: true,
            typingAnimation: '',
            pluginDragonAnimation:'',
        }
    },
    name:"helpmodule",
    inject: ['http'],
    computed: {
        user(){
            return this.$store.state.user;
        }
    },
    components:{},
    methods:{
        nextTalk(){
            let elStudentMenu = document.querySelectorAll('.help-module__highlight li')
            if(this.phraseNumber > 0 && this.phraseNumber < this.data.talkDrako.length - 1){
                elStudentMenu[this.phraseNumber-1].classList.remove('highlight')
            }
            if(this.phraseNumber < this.data.talkDrako.length - 1){
                elStudentMenu[this.phraseNumber].classList.add('highlight')
                this.phraseNumber++
            }
            if(this.phraseNumber > 4){
                this.$refs.drakoTop.style.top = '35%'
            }
        },
        closeTalk(){
            this.onWatchHelp()
            this.closeHelpModule = true
            document.querySelectorAll('.sc_first__drako')[0].classList.remove('hide-drako')
        },
        initNextTalk(){
            this.typingAnimation = new Typed('.typed', {
                strings: [this.data.talkDrako[this.phraseNumber].talk],
                typeSpeed: 10, //настройка скорости текста
                localPlDragonAnim: this.pluginDragonAnimation,
                localAnimDrako: this.animDrako,
                onReset: function(e){
                    if(!this.localAnimDrako){
                        document.querySelectorAll('.help-module__drako-talk button')[0].disabled = false
                        this.localPlDragonAnim[0].click()
                        document.querySelectorAll('.help-module__drako-talk button')[0].disabled = true
                    }
                    e.strings[0] = this.strings
                },
                onComplete: function(){
                    this.localAnimDrako = false
                    document.querySelectorAll('.help-module__drako-talk button')[0].disabled = false
                    this.localPlDragonAnim[0].click()
                    document.querySelectorAll('.help-module__drako-talk button')[0].disabled = true
                },
                showCursor: false
            });
        },
        initPluginDragonAnimation(){
            let pluginDragonAnimation = this.pluginDragonAnimation
            setTimeout(function() {
                pluginDragonAnimation[0].click()
                document.querySelectorAll('.help-module__drako-talk button')[0].disabled = true
            }, 350);
        },
        mobail(){
            let phraseNumber = this.phraseNumber
            let overallScreenSize = window.screen.width
            let availableScreenSize = window.innerWidth
            let availableScreenHeight = window.innerHeight
            let adapt = "start"
            if(overallScreenSize <= 640 || availableScreenSize <= 640){
                this.$refs.drakoMobail.onclick = function(){
                    let elStudentMenu = document.querySelectorAll('.help-module__highlight li')
                    elStudentMenu[phraseNumber-1].scrollIntoView({ block: adapt, behavior: "smooth"})
                }
            }
            if(availableScreenHeight <= 830 && (this.data.talkDrako.length - 1) - this.phraseNumber <= 2){
                adapt = "end"
                if(availableScreenHeight > 570 && availableScreenHeight > 720){
                    document.querySelectorAll('.help-module__content')[0].classList.add('help-module__content_top-mob-big')
                }
                console.log('Я поменялась')
                console.log((this.data.talkDrako.length - 1) - this.phraseNumber)
            }
            if(availableScreenHeight <= 720 && (this.data.talkDrako.length - 1) - this.phraseNumber <= 2){
                if(availableScreenHeight > 570){
                    document.querySelectorAll('.help-module__content')[0].classList.add('help-module__content_top-mob-standart')
                }
            }
            if(availableScreenHeight <= 570 && (this.data.talkDrako.length - 1) - this.phraseNumber <= 2){
                document.querySelectorAll('.help-module__content')[0].classList.add('help-module__content_top-mob-small')
            }
        },
        async onWatchHelp() {
            let data = {
                'param_name': 'help_module_watch',
                'param_value': true,
                'user_id': this.user.id
            }
            let result = await this.http.post('onUpdateUserParam', data).then(res => res.data);
        },
    },
    mounted() {
        this.pluginDragonAnimation = Gifffer()
        this.initNextTalk()
        this.mobail() 
        document.querySelectorAll('.sc_first__drako')[0].classList.add('hide-drako')
    },
    watch:{
        phraseNumber: function(){
            this.typingAnimation.reset()
            this.initNextTalk()
            this.mobail()
        },
        pluginDragonAnimation: function(){
            this.initPluginDragonAnimation()
        }
    },
}
</script>

<style lang="scss">
    .highlight {
        z-index: 1;
    }
    .hide-drako{
        display: none;
    }
    .help-module__drako-talk{
        button{
            max-width: 1260px;
            width: 100%!important;
            height: 100%!important;
            cursor: auto!important;
            div.gifffer-play-button{
                display:none;
            }
        }
    }
    .footer,
    .headline{
        z-index: 2;
        position: relative;
    }
    .sc_first{
        position: initial;
        &__drako {
            top: 23.5%;
        }
    }
</style>

<style lang="scss" scoped>
    .help-module{
        &__drako-reaction{
            height: -webkit-fill-available;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            position: relative;
            .drako-reaction{
                width: 865px;
                min-height: 97px;
                background: #009b01;
                padding: 20px;
                border-radius: 10px; 
                position: absolute;
                top: 55%;
                p{
                    font-size: 1.5rem;
                    text-transform: uppercase;
                }

                &__btn-close,
                &__btn-next{
                    position: absolute;
                    right:0;
                    cursor: pointer;
                }

                &__btn-close{
                    top: -50px;
                    svg{
                        font-size: 2.5rem;
                        color: #cd9933;
                    }
                }

                &__btn-next{
                    bottom: -150px;
                    svg{
                        font-size:4.5rem;
                        color:#009b01;
                    }
                }
            }
            .help-module__drako-talk{
                position: absolute;
                left: calc(50% - 1292px);
                top: 17%;
                img{
                    max-width: 1260px;
                    min-width: 1260px;
                }
            }
        }
        &__background {
            width: -webkit-fill-available;
            height: -webkit-fill-available;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            background: #0000009c;
        }
        &__content {
            width: 100%;
            height: 100vh;
            z-index: 3;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
        }
    }

    @media screen and(max-width:1200px){
        .help-module__content{
            .help-module__drako-reaction{
                width:100%;
                .drako-reaction{
                    width:74%;
                    min-width:580px;
                }
                .help-module__drako-talk{
                    display:none;
                }
                .drako-reaction__btn-next{
                    bottom:-110px;
                }
            }
        }
    }

    @media screen and(max-width: 640px){
        .help-module__content{
            position: fixed;
            top:250px;
            &_top-mob-small{
                top:165px;
            }
            &_top-mob-standart{
                top:310px;
            }
            &_top-mob-big{
                top:440px;
            }
            .help-module__drako-reaction{
                width: 100%;
                .drako-reaction{
                    width:80%;
                    min-width: auto;
                    top:0!important;
                    p{
                        font-size:1rem
                    }
                    &__btn-next{
                        bottom:-85px;
                        svg{
                            transform: rotate(90deg);
                        }
                    }
                }
            }
        }
    }
</style>